import { useGetAllPromoCodesQuery } from "@RTKQuery/admin/promoCodes/promoCodes";
import style from "./TableBody.module.scss";
import { useAppSelector } from "store/hooks";
import { PromoCode } from "@interfaces/admin/promoCode";

export function TableBody({
    children
}: {
    children: (data: PromoCode) => JSX.Element
}) {
    const activePaginationPage = useAppSelector(state => state.promoCodesAdminPage.activePaginationPage);

    const { data } = useGetAllPromoCodesQuery({
        page: activePaginationPage
    });

    return (
        <div className={style.body}>
            {
                data?.promo_codes.map(row => children(row))
            }
        </div>
    )
}

